import Vue from 'vue'
import Vuex from 'vuex'
import getters from '@/store/getters.js'
import app from '@/store/modules/app.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app
  },
  getters
})
export default store
